const dataGrid = {
  defaultBaseWidth: 160,
  defaultActionWidth: 120,
  smallActionWidth: 80,
  defaultDateWidth: 100,
  defaultDateTimeWidth: 180,
}

export default dataGrid
